"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fontIcon = _interopRequireDefault(require("../../atoms/font-icon"));

var _text = _interopRequireDefault(require("../../atoms/text"));

var _link = _interopRequireDefault(require("../../atoms/link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  align-items: baseline;\n  margin: 4px 12px;\n  padding: 0;\n  cursor: ", ";\n  pointer-events: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledPaginationButton = (0, _styledComponents["default"])(_link["default"])(_templateObject(), function (props) {
  return props.isActive ? 'default' : 'pointer';
}, function (props) {
  return props.isDisabled ? 'none' : 'all';
});
var StyledPaginationButtonText = (0, _styledComponents["default"])(_text["default"])(_templateObject2(), function (props) {
  return props.isDisabled ? '#969AA3' : '#161616';
}, function (props) {
  if (props.hasLeftIcon) return '0 0 0 10px';
  return '0 10px 0 0';
});

var PaginationButton = function PaginationButton(props) {
  var changePage = props.changePage,
      pageNumber = props.pageNumber,
      isDisabled = props.isDisabled,
      hasLeftIcon = props.hasLeftIcon,
      buttonText = props.buttonText;
  return _react["default"].createElement(StyledPaginationButton, {
    isDisabled: isDisabled,
    onClick: function onClick() {
      changePage(pageNumber);
    }
  }, hasLeftIcon && _react["default"].createElement(_fontIcon["default"], {
    color: isDisabled ? 'ashGrey' : 'black',
    children: "icon-arrow-left",
    size: 12
  }), _react["default"].createElement(StyledPaginationButtonText, {
    isDisabled: isDisabled,
    hasLeftIcon: hasLeftIcon,
    size: 5
  }, buttonText), !hasLeftIcon && _react["default"].createElement(_fontIcon["default"], {
    color: isDisabled ? 'ashGrey' : 'black',
    children: "icon-arrow-right",
    size: 12
  }));
};

var _default = PaginationButton;
exports["default"] = _default;